import { Box } from '@mui/material';

import { QuestionCard } from '@/components';
import type { MarketIcon } from '@/types';

type QuestionCardData = {
  id: string;
  question: string;
  icon?: MarketIcon;
  iconImage?: React.ReactNode;
  chance: string;
  volume: string;
  showRefreshIcon?: boolean;
  showGiftIcon?: boolean;
};

const QUESTION_CARDS: QuestionCardData[] = [
  {
    id: 'btc-price-dec-19',
    question: 'Bitcoin above ___ on December 19?',
    icon: 'bitcoin',
    chance: '100%',
    volume: '$2m',
    showRefreshIcon: true,
    showGiftIcon: true,
  },
];

type QuestionCardItemProps = {
  questionCard: QuestionCardData;
  onTradeClick?: (cardId: string, isYes: boolean) => void;
};

const QuestionCardItem = ({ questionCard, onTradeClick }: QuestionCardItemProps) => {
  return (
    <QuestionCard
      id={questionCard.id}
      question={questionCard.question}
      icon={questionCard.icon}
      iconImage={questionCard.iconImage}
      chance={questionCard.chance}
      volume={Number(questionCard.volume)}
      onTradeClick={onTradeClick}
      showRefreshIcon={questionCard.showRefreshIcon}
      showGiftIcon={questionCard.showGiftIcon}
    />
  );
};

type QuestionCardListProps = {
  onTradeClick?: (cardId: string, isYes: boolean) => void;
};

export const QuestionCardList = ({ onTradeClick }: QuestionCardListProps) => {
  return (
    <>
      {QUESTION_CARDS.map((questionCard) => (
        <QuestionCardItem
          key={questionCard.id}
          questionCard={questionCard}
          onTradeClick={onTradeClick}
        />
      ))}
    </>
  );
};

export default QuestionCardList;
